import * as React from 'react';
import StyledFilterContainer from 'flow-doctor-lib/components/filters/StyledFilterContainer';
import ClassicReenrollmentFilterRenderer from 'flow-doctor-lib/components/filters/classicReenrollment/ClassicReenrollmentFilterRenderer';
import WalmartFilterBranchOperatorLabel from 'flow-doctor-lib/components/filters/WalmartFilterBranchOperatorLabel';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ClassicReenrollmentTriggerSetsRenderer = ({
  reEnrollmentTriggerSets,
  objectTypeId,
  condensed,
  portalId
}) => {
  return /*#__PURE__*/_jsx(StyledFilterContainer, {
    filterWidthType: condensed ? 'DEFAULT' : 'LIST_STRETCHED',
    children: reEnrollmentTriggerSets.map((triggerSet, i) => /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ClassicReenrollmentFilterRenderer, {
        portalId: portalId,
        objectTypeId: objectTypeId,
        condensed: condensed,
        reEnrollmentTriggerSet: triggerSet
      }), i < reEnrollmentTriggerSets.length - 1 && /*#__PURE__*/_jsx(WalmartFilterBranchOperatorLabel, {
        filterBranchOperator: "OR"
      })]
    }))
  });
};
export default ClassicReenrollmentTriggerSetsRenderer;